import { data } from '../../svg/CheckCircle/data';
import { makeIcon } from '../makeIcon';

export const CheckCircle = makeIcon(data, 'check_circle', 'CheckCircle');

export default CheckCircle;
